import React from "react";
import { SearchResult } from "./SearchResult";
import "./SearchResultsList.css";

export const SearchResultsList = ({ results, onResultClick, clearInput }) => {
  return (
    <div className="results-list">
      {results.map((result, id) => {
        return (
          <SearchResult
            result={result}
            onResultClick={() => onResultClick(result)} // Call handleKeywordClick
            key={id}
            clearInput={clearInput}
          />
        );
      })}
    </div>
  );
};
